import React from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Home from "../pages/Home";
import Login from "../pages/Login";
import SignUp from "../pages/SignUp";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import AllUserProducts from "../pages/AllUserProducts";

//Admin Panel Pages
import Dashboard from "../panelPages/Dashboard";
import Layout from "../panelComponents/Layout";
import Categories from "../panelPages/Categories";
import AllUsers from "../panelPages/AllUsers";
import NotFound from "../pages/NotFound";
import AllProducts from "../panelPages/AllProducts";
import ProductUpload from "../panelComponents/AllProductsComponent/ProductUpload";
import AllBanners from "../panelPages/AllBanners";
import CategoryPage from "../pages/CategoryPage";
import ProductDetails from "../pages/ProductDetails";
import ProfileLayout from "../pages/ProfileLayout";
import ProfilePage from "../pages/ProfilePage";
import AddressPage from "../pages/AddressPage";
import Wishlist from "../pages/Wishlist";
// import Coupon from "../pages/Coupon";
import Settings from "../pages/Settings";
import AllCoupons from "../panelPages/AllCoupons";
import OrdersPage from "../pages/OrdersPage";
import OrderDetailsPage from "../components/myAccountComponents/OrderDetailsPage";
import AddressDetailForm from "../components/myAccountComponents/AddressDetailForm";
import CartPage from "../pages/CartPage";
import CheckOutPage from "../pages/CheckOutPage";
import SimilarProducts from "../pages/SimilarProducts";
import SuccessPage from "../pages/SuccessPage";
import CancelPage from "../pages/CancelPage";
import AllOrders from "../panelPages/AllOrders";
import ContactUs from "../pages/ContactUs";
import NewArrivals from "../components/HomeComponents/NewArrivals";
import TermsAndConditions from "../pages/PolicyPages/TermsAndConditions";
import SafePurchase from "../pages/PolicyPages/SafePurchase";
import ExchangePolicy from "../pages/PolicyPages/ExchangePolicy";
import ReturnRefundPolicy from "../pages/PolicyPages/ReturnRefundPolicy";
import ShippingPolicy from "../pages/PolicyPages/ShippingPolicy";
import PrivacyPolicy from "../pages/PolicyPages/PrivacyPolicy";
import OrderDetails from "../panelComponents/AllOrderComponent/OrderDetails";
import AllReturnOrders from "../panelPages/AllReturnOrders";
import SearchResultsPage from "../pages/SearchResultsPage";


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/sign-up",
        element: <SignUp />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },

      {
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
      {
        path: "/category/:categoryName",
        element: <CategoryPage />,
      },
      {
        path: "/all-userproducts/:subCategorySlug",
        element: <AllUserProducts />,
      },
      {
        path: "/all-userproducts",
        element: <AllUserProducts />,
      },
      {
        path: "view-one-product/:productId",
        element: <ProductDetails />
      },
      {
        path: "/cart-page",
        element: <CartPage />
      },
      {
        path: "/check-out-page",
        element: <CheckOutPage />
      },
      {
        path: "/success",
        element: <SuccessPage />
      },
      {
        path: "/cancel",
        element: <CancelPage />
      },
      {
        path: "/similar-products",
        element: <SimilarProducts />
      },
      {
        path: "/contact-us",
        element: <ContactUs />
      },
      {
        path: "/new-arrivals",
        element: <NewArrivals />
      },

      //Policy Pages
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />
      },
      {
        path: "/safe-purchase",
        element: <SafePurchase />
      },
      {
        path: "/exchange-policy",
        element: <ExchangePolicy />
      },
      {
        path: "/shipping-policy",
        element: <ShippingPolicy />
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />
      },
      {
        path: "/return-refund-policy",
        element: <ReturnRefundPolicy />
      },
      {
        path: "/search",
        element: <SearchResultsPage />
      },
      
      {
        path: "admin-panel",
        element: <Layout />,
        children: [
          {
            path: "",
            element: <Dashboard />
          },
          {
            path: "all-orders",
            element: <AllOrders />
          },
          {
            path: "all-orders/:orderId",
            element: <OrderDetails />
          },
          {
            path: "return-orders",
            element: <AllReturnOrders />
          },
          {
            path: "all-users",
            element: <AllUsers />
          },
          {
            path: "all-categories",
            element: <Categories />
          },
          {
            path: "all-products",
            element: <AllProducts />
          },
          {
            path: "all-products/upload",
            element: <ProductUpload />
          },
          {
            path: "all-products/upload/:id",
            element: <ProductUpload />
          },
          {
            path: "all-coupons",
            element: <AllCoupons />
          },
          {
            path: "all-banners",
            element: <AllBanners />
          },

          // {
          //   path: "all-products",
          //   element: <AllProducts />
          // },
          // {
          //   path: "upload-products",
          //   element: <UploadProducts />
          // },
          // {
          //   path: "upload-products/edit/:id",
          //   element: <UploadProducts isEditMode={true} />
          // },
          // {
          //   path: "attribute-manager",
          //   element: <AttributeManager />
          // }
        ]
      },
      {
        path: "my-account",
        element: <ProfileLayout />,
        children: [
          { path: "menu", element: <div /> },
          { index: true, element: <ProfilePage /> },
          { path: "my-orders", element: <OrdersPage /> },
          { path: "my-orders/:orderId", element: <OrderDetailsPage /> },
          { path: "address", element: <AddressPage /> },
          { path: "address/new", element: <AddressDetailForm /> },
          { path: "address/edit/:id", element: <AddressDetailForm /> },
          { path: "wishlist", element: <Wishlist /> },
          // { path: "coupon", element: <Coupon /> },
          { path: "settings", element: <Settings /> },
        ]
      }
    ],
    
  },
]);

export default router;
